import { render, staticRenderFns } from "./FormImportFeedback.vue?vue&type=template&id=a4c0ce78"
import script from "./FormImportFeedback.vue?vue&type=script&lang=js"
export * from "./FormImportFeedback.vue?vue&type=script&lang=js"
import style0 from "./FormImportFeedback.vue?vue&type=style&index=0&id=a4c0ce78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports